import React from 'react';
import { Badge } from 'react-bootstrap';

interface DoorStatusBadgeProps {
  isOpen: boolean;
  className?: string;
}

export const DoorStatusBadge: React.FC<DoorStatusBadgeProps> = ({ isOpen, className = '' }) => {
  return (
    <Badge
      bg={isOpen ? 'warning' : 'success'}
      className={className}
    >
      {isOpen ? '○ Open' : '● Closed'}
    </Badge>
  );
};